module.exports = __webpack_public_path__ + "img/user-pic.7adb51ef.png";